import { Component, inject, OnDestroy } from '@angular/core'
import { Router } from '@angular/router'
import { LicenseUploadDialogComponent } from '@dot-it/jml-lib'
import { DialogService } from 'primeng/dynamicdialog'
import { Subscription } from 'rxjs'

@Component({
  selector: 'jml-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnDestroy {
  subscriptions: Subscription[] = []

  currentYear: number

  dialogService = inject(DialogService)
  router = inject(Router)

  constructor() {
    this.currentYear = new Date().getFullYear()
  }

  uploadLicense() {
    const dialogRef = this.dialogService.open(LicenseUploadDialogComponent, {
      data: {},
      header: 'Lizenz hochladen',
      draggable: true,
      width: '800px'
    })

    this.subscriptions.push(
      dialogRef.onClose.subscribe((data: any) => {
        const currentUrl = this.router.url

        if (data) {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([currentUrl, encodeURIComponent(data)]).then(() => {})
          })
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe())
  }
}
